/* ═══════════════════════════════════════════════════
   LUMIÈRE — lumiere.js for Horizon theme
   assets/lumiere.js
   ═══════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── CONFIG ── */
  const CONFIG = {
    showWishlist:       true,
    showFilters:        true,
    isLoggedIn:         window.__lumiere_logged_in__ || false,
    popupTitle:         window.__lumiere_popup_title__          || 'Save your favourites',
    popupText:          window.__lumiere_popup_text__           || 'Create an account to save items to your wishlist and access them anytime.',
    popupShowPromo:     window.__lumiere_popup_show_promo__     !== false,
    popupPromoLabel:    window.__lumiere_popup_promo_label__    || 'Welcome gift',
    popupPromoCode:     window.__lumiere_popup_promo_code__     || 'WELCOME10',
    popupPromoDiscount: window.__lumiere_popup_promo_pct__      || '–10%',
    popupRegisterText:  window.__lumiere_register_text__        || 'Create account',
    popupRegisterUrl:   window.__lumiere_register_url__         || '/account/register',
    popupLoginText:     window.__lumiere_login_text__           || 'Sign in',
    popupLoginUrl:      window.__lumiere_login_url__            || '/account/login',
    toastTitle:         window.__lumiere_toast_title__          || 'Added to cart',
    toastSub:           window.__lumiere_toast_sub__            || 'added to your cart',
  };

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ════════════════════════════════════════
     WISHLIST STORAGE
  ════════════════════════════════════════ */
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem('lum_wishlist') || '[]'); }
    catch { return []; }
  }
  function saveWishlist(list) { localStorage.setItem('lum_wishlist', JSON.stringify(list)); }
  function isWishlisted(id)   { return getWishlist().includes(String(id)); }

  /* ════════════════════════════════════════
     POPUP
  ════════════════════════════════════════ */
  let popupEl = null;

  function buildPopup() {
    if (popupEl) return;
    popupEl = document.createElement('div');
    popupEl.className = 'lum-popup-overlay';
    popupEl.setAttribute('role', 'dialog');
    popupEl.setAttribute('aria-modal', 'true');
    popupEl.innerHTML = `
      <div class="lum-popup">
        <button class="lum-popup__close" aria-label="Close">
          <svg viewBox="0 0 24 24"><path d="M18 6 6 18M6 6l12 12" stroke-linecap="round"/></svg>
        </button>
        <div class="lum-popup__icon">
          <svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
        </div>
        <h2 class="lum-popup__title">${CONFIG.popupTitle}</h2>
        <p class="lum-popup__text">${CONFIG.popupText}</p>
        ${CONFIG.popupShowPromo ? `
        <div class="lum-popup__promo">
          <span class="lum-popup__promo-label">${CONFIG.popupPromoLabel}</span>
          <span class="lum-popup__promo-code">${CONFIG.popupPromoCode}</span>
          <span class="lum-popup__promo-discount">${CONFIG.popupPromoDiscount}</span>
        </div>` : ''}
        <div class="lum-popup__btns">
          <a href="${CONFIG.popupRegisterUrl}" class="lum-popup__btn-primary">${CONFIG.popupRegisterText}</a>
          <a href="${CONFIG.popupLoginUrl}"    class="lum-popup__btn-secondary">${CONFIG.popupLoginText}</a>
        </div>
      </div>`;
    document.body.appendChild(popupEl);
    popupEl.querySelector('.lum-popup__close').addEventListener('click', closePopup);
    popupEl.addEventListener('click', e => { if (e.target === popupEl) closePopup(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closePopup(); });
  }

  function openPopup()  { buildPopup(); requestAnimationFrame(() => popupEl.classList.add('lum-open')); document.body.style.overflow = 'hidden'; }
  function closePopup() { if (!popupEl) return; popupEl.classList.remove('lum-open'); document.body.style.overflow = ''; }

  /* ════════════════════════════════════════
     CART TOAST
  ════════════════════════════════════════ */
  let toastEl = null, toastTimer = null;

  function buildToast() {
    if (toastEl) return;
    toastEl = document.createElement('div');
    toastEl.className = 'lum-toast';
    toastEl.style.display = 'none';
    toastEl.setAttribute('role', 'status');
    toastEl.innerHTML = `
      <div class="lum-toast__icon">
        <svg viewBox="0 0 24 24" fill="none" stroke-width="1.5"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" stroke-linecap="round"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
      </div>
      <div class="lum-toast__body">
        <div class="lum-toast__title" id="lumToastTitle"></div>
        <div class="lum-toast__sub"   id="lumToastSub"></div>
      </div>
      <button class="lum-toast__close" aria-label="Close">
        <svg viewBox="0 0 24 24"><path d="M18 6 6 18M6 6l12 12" stroke-linecap="round"/></svg>
      </button>`;
    document.body.appendChild(toastEl);
    toastEl.querySelector('.lum-toast__close').addEventListener('click', hideToast);
  }

  function showToast(title, sub) {
    buildToast();
    document.getElementById('lumToastTitle').textContent = title || CONFIG.toastTitle;
    document.getElementById('lumToastSub').textContent   = sub   || '';
    toastEl.style.display = 'flex';
    toastEl.classList.remove('lum-toast--hiding');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 4500);
  }

  function hideToast() {
    if (!toastEl) return;
    toastEl.classList.add('lum-toast--hiding');
    setTimeout(() => { if (toastEl) { toastEl.style.display = 'none'; toastEl.classList.remove('lum-toast--hiding'); }}, 350);
  }

  /* ════════════════════════════════════════
     WISHLIST BUTTONS — inject into card galleries
  ════════════════════════════════════════ */
  function injectWishBtn(cardContent) {
    if (!CONFIG.showWishlist) return;
    if (cardContent.querySelector('.lum-wish-btn')) return;

    const productId = cardContent.closest('[data-product-id]')?.dataset?.productId;
    if (!productId) return;

    const gallery = cardContent.querySelector('.card-gallery');
    if (!gallery) return;

    const btn = document.createElement('button');
    btn.className  = 'lum-wish-btn' + (isWishlisted(productId) ? ' lum-wish-btn--active' : '');
    btn.type       = 'button';
    btn.dataset.productId = productId;
    btn.setAttribute('aria-label', 'Add to wishlist');
    btn.innerHTML  = `<svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>`;
    gallery.appendChild(btn);
    btn.addEventListener('click', handleWishClick);
  }

  function handleWishClick(e) {
    e.preventDefault(); e.stopPropagation();
    if (!CONFIG.isLoggedIn) { openPopup(); return; }

    const btn = e.currentTarget;
    const id  = btn.dataset.productId;
    const list = getWishlist();
    const idx  = list.indexOf(String(id));

    if (idx === -1) {
      list.push(String(id));
      btn.classList.add('lum-wish-btn--active');
      const spark = document.createElement('span');
      spark.className   = 'lum-sparkle';
      spark.textContent = '✦';
      btn.appendChild(spark);
      setTimeout(() => spark.remove(), 600);
    } else {
      list.splice(idx, 1);
      btn.classList.remove('lum-wish-btn--active');
    }
    saveWishlist(list);
    document.querySelectorAll(`.lum-wish-btn[data-product-id="${id}"]`).forEach(b => {
      b.classList.toggle('lum-wish-btn--active', list.includes(String(id)));
    });
  }

  /* ════════════════════════════════════════
     QUICK-ADD ENHANCEMENTS
  ════════════════════════════════════════ */
  function enhanceQuickAdd(cardContent) {
    const btn = cardContent.querySelector(
      '.quick-add__button, .quick-add button[type="submit"], .quick-add .button'
    );
    if (!btn || btn.dataset.lumEnhanced) return;
    btn.dataset.lumEnhanced = '1';

    btn.addEventListener('click', function (e) {
      const ripple = document.createElement('span');
      ripple.className = 'lum-ripple';
      const rect = btn.getBoundingClientRect();
      ripple.style.left = (e.clientX - rect.left) + 'px';
      ripple.style.top  = (e.clientY - rect.top)  + 'px';
      btn.appendChild(ripple);
      setTimeout(() => ripple.remove(), 600);
    });

    const productTitle = cardContent.closest('[data-product-title]')?.dataset?.productTitle
      || cardContent.querySelector('.h4, [class*="product-title"]')?.textContent?.trim()
      || '';

    // Horizon fires cart:add on quick-add-component
    const qa = cardContent.querySelector('quick-add-component');
    if (qa) {
      qa.addEventListener('cart:add', () => {
        showToast(productTitle, `1 × ${CONFIG.toastSub}`);
        doPop(btn);
      });
    }

    // Fallback: watch button text for "Added"
    new MutationObserver(() => {
      if (/added|✓/i.test(btn.textContent)) { showToast(productTitle, `1 × ${CONFIG.toastSub}`); doPop(btn); }
    }).observe(btn, { childList: true, subtree: true, characterData: true });
  }

  function doPop(btn) {
    btn.style.animation = 'none';
    requestAnimationFrame(() => { btn.style.animation = 'lumCartPop .45s ease'; });
    setTimeout(() => { btn.style.animation = ''; }, 500);
  }

  /* ════════════════════════════════════════
     FILTER SIDEBAR
     Structure from console:
       #ResultsList  ← grid main-collection-grid (this is what we want to sit beside)
         inside results-list > collection-wrapper > ...

     Horizon's facets: DIV.facets-block-wrapper--horizontal  ← already in DOM
     We build our sidebar from its checkboxes/inputs and insert BEFORE #ResultsList
     inside the same parent (collection-wrapper div).
  ════════════════════════════════════════ */
  function buildFilterSidebar() {
    if (!CONFIG.showFilters) return;
    if (document.querySelector('.lum-sidebar')) return;

    const resultsDiv = document.getElementById('ResultsList');
    if (!resultsDiv) return;

    // The facets wrapper Horizon already rendered
    const facetsWrapper = document.querySelector('.facets-block-wrapper');
    if (!facetsWrapper) return;

    /* Build sidebar HTML from Horizon's facet data */
    const sidebar = document.createElement('aside');
    sidebar.className = 'lum-sidebar';

    // Count active filters
    const activeFilters = facetsWrapper.querySelectorAll('input[type="checkbox"]:checked').length;
    const clearUrl      = window.location.pathname;

    sidebar.innerHTML = `
      <div class="lum-sidebar__head">
        <h2 class="lum-sidebar__title">Filter</h2>
        ${activeFilters > 0 ? `<a href="${clearUrl}" class="lum-sidebar__clear">Clear all</a>` : ''}
      </div>`;

    /* Parse each filter group from Horizon's facets */
    // Horizon renders details/summary or labelled sections — try both
    const groups = facetsWrapper.querySelectorAll('details, [class*="facets__item"], [class*="accordion__item"]');

    groups.forEach(group => {
      const labelEl = group.querySelector('summary, legend, [class*="label"], h2, h3, h4');
      const label   = labelEl ? labelEl.textContent.trim().split('\n')[0].trim() : '';
      if (!label) return;

      const checkboxes = group.querySelectorAll('input[type="checkbox"]');
      const minInput   = group.querySelector('input[name*="min"], input[id*="min"]');
      const maxInput   = group.querySelector('input[name*="max"], input[id*="max"]');

      const fg = document.createElement('div');
      fg.className = 'lum-fg lum-fg--open';

      let bodyHtml = '';

      if (minInput && maxInput) {
        /* Price range */
        bodyHtml = `
          <form class="lum-price-form" data-lum-price>
            <div class="lum-price-inputs">
              <input class="lum-price-input" type="number" name="${minInput.name}"
                value="${minInput.value || ''}" placeholder="${minInput.placeholder || '0'}" min="0">
              <span class="lum-price-sep">—</span>
              <input class="lum-price-input" type="number" name="${maxInput.name}"
                value="${maxInput.value || ''}" placeholder="${maxInput.placeholder || ''}" min="0">
            </div>
            <button type="submit" class="lum-price-submit">Apply</button>
          </form>`;
      } else if (checkboxes.length > 0) {
        const isColor = /colou?r/i.test(label);

        if (isColor) {
          bodyHtml = '<div class="lum-swatches">';
          checkboxes.forEach(cb => {
            const li      = cb.closest('li, label, [class*="item"]');
            const cbLabel = li?.querySelector('[class*="label"], span')?.textContent?.trim() || cb.value;
            const active  = cb.checked ? 'lum-swatch-btn--active' : '';
            const href    = cb.checked ? buildRemoveUrl(cb.name, cb.value) : buildAddUrl(cb.name, cb.value);
            const color   = cb.value.toLowerCase().replace(/\s+/g, '');
            bodyHtml += `
              <a href="${href}" class="lum-swatch-btn ${active}" title="${cbLabel}">
                <span class="lum-swatch-dot" style="background-color:${color};"></span>
                <span class="lum-swatch-name">${cbLabel}</span>
              </a>`;
          });
          bodyHtml += '</div>';
        } else {
          bodyHtml = '<ul class="lum-fl">';
          checkboxes.forEach(cb => {
            const li      = cb.closest('li, label, [class*="item"]');
            const cbLabel = (li?.textContent || cb.value).replace(/\(\d+\)/, '').trim().split('\n')[0].trim();
            const countEl = li?.querySelector('[class*="count"], [class*="badge"]');
            const count   = countEl ? countEl.textContent.trim() : '';
            const active  = cb.checked ? 'lum-fl__active' : '';
            const href    = cb.checked ? buildRemoveUrl(cb.name, cb.value) : buildAddUrl(cb.name, cb.value);
            bodyHtml += `
              <li class="lum-fl__item ${active}">
                <a href="${href}">
                  <span class="lum-check">
                    <svg viewBox="0 0 10 8"><path d="m1 4 3 3 5-6" stroke-linecap="round" stroke-linejoin="round"/></svg>
                  </span>
                  ${cbLabel}
                  ${count ? `<span class="lum-fl__count">(${count})</span>` : ''}
                </a>
              </li>`;
          });
          bodyHtml += '</ul>';
        }
      }

      if (!bodyHtml) return;

      fg.innerHTML = `
        <button class="lum-fg__btn" type="button" aria-expanded="true">
          <span class="lum-fg__label">${label}</span>
          <svg class="lum-fg__chevron" viewBox="0 0 24 24" fill="none" stroke-width="1.5">
            <path d="m6 9 6 6 6-6" stroke-linecap="round"/>
          </svg>
        </button>
        <div class="lum-fg__body">${bodyHtml}</div>`;

      fg.querySelector('.lum-fg__btn').addEventListener('click', () => {
        fg.classList.toggle('lum-fg--open');
        fg.querySelector('.lum-fg__btn').setAttribute('aria-expanded', fg.classList.contains('lum-fg--open'));
      });

      sidebar.appendChild(fg);
    });

    /* Price forms submit handler */
    sidebar.querySelectorAll('[data-lum-price]').forEach(form => {
      form.addEventListener('submit', e => {
        e.preventDefault();
        const url = new URL(window.location.href);
        form.querySelectorAll('input[type="number"]').forEach(inp => {
          const val = parseFloat(inp.value);
          if (!isNaN(val)) url.searchParams.set(inp.name, Math.round(val * 100));
          else             url.searchParams.delete(inp.name);
        });
        window.location.href = url.toString();
      });
    });

    /* ── Insert sidebar + wrap ──
       resultsDiv.parentNode is the collection-wrapper div (level 2 in console output).
       We wrap resultsDiv with a flex container and prepend the sidebar.
    */
    const parent = resultsDiv.parentNode;

    // Remove any previously broken wrap from old code
    const oldWrap = document.querySelector('.lum-sidebar-wrap');
    if (oldWrap && oldWrap !== parent) {
      while (oldWrap.firstChild) oldWrap.parentNode.insertBefore(oldWrap.firstChild, oldWrap);
      oldWrap.remove();
    }

    const wrap = document.createElement('div');
    wrap.className = 'lum-sidebar-wrap';
    parent.insertBefore(wrap, resultsDiv);
    wrap.appendChild(sidebar);
    wrap.appendChild(resultsDiv);

    /* Build mobile drawer (clone sidebar content) */
    buildMobileDrawer(sidebar.cloneNode(true));

    /* Build toolbar (mobile filter btn + active pills) */
    buildToolbar(resultsDiv, activeFilters);

    /* Hide Horizon's own facets UI — we replaced it */
    facetsWrapper.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;opacity:0;pointer-events:none;';
  }

  function buildAddUrl(name, value) {
    const url = new URL(window.location.href);
    const existing = url.searchParams.getAll(name);
    if (!existing.includes(value)) url.searchParams.append(name, value);
    return url.toString();
  }

  function buildRemoveUrl(name, value) {
    const url = new URL(window.location.href);
    const remaining = url.searchParams.getAll(name).filter(v => v !== value);
    url.searchParams.delete(name);
    remaining.forEach(v => url.searchParams.append(name, v));
    return url.toString();
  }

  /* ── Mobile drawer ── */
  function buildMobileDrawer(sidebarClone) {
    const existing = document.getElementById('lumDrawer');
    if (existing) existing.remove();

    const drawer = document.createElement('div');
    drawer.className = 'lum-drawer-overlay';
    drawer.id = 'lumDrawer';
    drawer.innerHTML = `
      <div class="lum-drawer-bg" id="lumDrawerBg"></div>
      <div class="lum-drawer">
        <div class="lum-drawer-handle"></div>
        <div class="lum-drawer-head">
          <h3>Filter</h3>
          <button class="lum-drawer-close" id="lumDrawerClose">
            <svg viewBox="0 0 24 24" fill="none"><path d="M18 6 6 18M6 6l12 12" stroke-linecap="round" stroke-width="1.5"/></svg>
          </button>
        </div>
        <div id="lumDrawerBody"></div>
      </div>`;
    document.body.appendChild(drawer);

    document.getElementById('lumDrawerBody').appendChild(sidebarClone.querySelector('.lum-sidebar__head')?.nextElementSibling
      ? sidebarClone : document.createDocumentFragment());

    // Copy all fg groups into drawer
    sidebarClone.querySelectorAll('.lum-fg').forEach(fg => {
      document.getElementById('lumDrawerBody').appendChild(fg);
    });

    // Re-attach price form handlers in drawer
    drawer.querySelectorAll('[data-lum-price]').forEach(form => {
      form.addEventListener('submit', e => {
        e.preventDefault();
        const url = new URL(window.location.href);
        form.querySelectorAll('input[type="number"]').forEach(inp => {
          const val = parseFloat(inp.value);
          if (!isNaN(val)) url.searchParams.set(inp.name, Math.round(val * 100));
          else             url.searchParams.delete(inp.name);
        });
        window.location.href = url.toString();
      });
    });

    document.getElementById('lumDrawerBg').addEventListener('click',    closeMobileDrawer);
    document.getElementById('lumDrawerClose').addEventListener('click',  closeMobileDrawer);

    // Accordion in drawer
    drawer.querySelectorAll('.lum-fg__btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const fg = btn.closest('.lum-fg');
        fg.classList.toggle('lum-fg--open');
        btn.setAttribute('aria-expanded', fg.classList.contains('lum-fg--open'));
      });
    });
  }

  function buildToolbar(resultsDiv, activeCount) {
    if (document.querySelector('.lum-toolbar')) return;
    const toolbar = document.createElement('div');
    toolbar.className = 'lum-toolbar';
    toolbar.innerHTML = `
      <div class="lum-toolbar__left">
        <button class="lum-mob-filter-btn" id="lumMobFilterBtn" type="button">
          <svg viewBox="0 0 24 24" fill="none" stroke-width="1.5">
            <line x1="4" y1="6" x2="20" y2="6" stroke-linecap="round"/>
            <line x1="8" y1="12" x2="16" y2="12" stroke-linecap="round"/>
            <line x1="12" y1="18" x2="12" y2="18" stroke-linecap="round"/>
          </svg>
          Filter
          ${activeCount > 0 ? `<span class="lum-filter-badge">${activeCount}</span>` : ''}
        </button>
      </div>`;
    resultsDiv.insertBefore(toolbar, resultsDiv.firstChild);
    document.getElementById('lumMobFilterBtn')?.addEventListener('click', openMobileDrawer);
  }

  function openMobileDrawer()  { document.getElementById('lumDrawer')?.classList.add('lum-open');    document.body.style.overflow = 'hidden'; }
  function closeMobileDrawer() { document.getElementById('lumDrawer')?.classList.remove('lum-open'); document.body.style.overflow = ''; }

  /* ════════════════════════════════════════
     PROCESS CARDS
  ════════════════════════════════════════ */
  function processCard(el) {
    injectWishBtn(el);
    enhanceQuickAdd(el);
  }

  function processAllCards() {
    document.querySelectorAll('.product-card__content.product-grid__card').forEach(processCard);
  }

  function observeGrid() {
    const grid = document.querySelector('.product-grid');
    if (!grid) return;
    new MutationObserver(mutations => {
      mutations.forEach(m => m.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.classList?.contains('product-card__content')) { processCard(node); return; }
        node.querySelectorAll?.('.product-card__content.product-grid__card').forEach(processCard);
      }));
    }).observe(grid, { childList: true, subtree: true });
  }

  /* ════════════════════════════════════════
     INIT
  ════════════════════════════════════════ */
  ready(() => {
    processAllCards();
    observeGrid();
    buildFilterSidebar();
  });

})();